import styled from 'styled-components';

import ActionButton from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { primitive } from 'styles/constants/primitives';
import { fadeIn } from 'utils/style/animations';

export const AvailablePointsCaption = styled.div`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9rem;
  margin-left: 0.4rem;
  ${Styles.mobileTiny`
    font-size: 0.79rem;
  `}
  ${Styles.desktop`
    text-align: left
  `}
`;

export const BannerContainer = styled.div`
  padding: 0 1rem;
  overflow: hidden;
  position: relative;
  animation: ${fadeIn} 0.4s forwards;
  font-family: ${Styles.fontFamily.base};
  background-color: ${primitive.$white};
  color: ${Styles.color.black};
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  ${Styles.desktop`
   padding-bottom: 1rem;
   grid-template-columns: repeat(12, 1fr);
   grid-template-rows: 1fr;
  `}
`;

export const CurrentProgress = styled.span<{ $progress: number }>`
  display: block;
  width: ${p => `calc(${p.$progress}%)`};
  border-radius: 1.5625rem;
  height: 0.165rem;
  background-color: ${Styles.color.highlight};
`;

export const DashboardButton = styled(ActionButton)`
  font-family: ${Styles.fontFamily.brand};
  font-size: 0.8125;
  background-color: ${Styles.color.highlight};
  border-color: ${Styles.color.highlight};
  color: ${primitive.$white};
  grid-column: 3/4;
  align-self: flex-start;
  height: 2.2rem;
  padding: 0 1rem;
  margin-top: 1rem;
  width: 45vw;
  ${Styles.desktop`
    grid-column: 12;
    height: 2.5rem;
    min-width: 4rem;
    max-width: 9.5rem;
    padding: 0rem;
    font-size: 1rem;
  `}
`;

export const PointsContainer = styled.div`
  span {
    font-size: 2.5rem;
    margin-left: 0.4rem;
    ${Styles.mobileTiny`
      font-size: 1.6rem;
    `}
  }
`;

export const PointsProgress = styled.div`
  grid-row: 2;
  grid-column: 1/4;
  width: calc(100% - 2rem);
  align-self: center;
  position: relative;
  background-color: ${Styles.color.grey.eight};
  border-radius: 1.5625rem;
  margin: 0 0 1rem 0.4rem;
  ${Styles.desktop`
    grid-column: 3/11;
    grid-row: 1;
    width: 100%;
    margin: 0;
  `}
`;

export const PointsProgressContainer = styled.div`
  height: 7.5vh;
  margin-top: 2.5vh;
  ${Styles.desktop`
    height: 5vh;
    padding: 0 1.5rem;
  `}
`;

export const RewardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${Styles.desktop`
    margin-top: 1vh;
    padding: 0 1.5rem;
  `}
`;

export const UserRewardPointsContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  ${Styles.mobileTiny`
    font-size: 0.8rem;
  `}
`;

export const StyledLoyaltyPointsIcon = styled(LoyaltyPointsIcon)`
  height: 2rem;
  width: 2rem;
  path {
    fill: ${p => p.theme.token('text-loyalty-highlight')};
  }
  ${Styles.mobileTiny`
    width: 2.375rem;
  `}
`;

export const TierDot = styled.div<{ completed: boolean; left?: number; value: string }>`
  height: 0.6875rem;
  width: 0.6875rem;
  position: absolute;
  border-radius: 1.5625rem;
  margin-top: -0.249rem;
  margin-left: ${p => `calc(${p.left || 0}%)`};
  background: ${p => (p.completed ? Styles.color.highlight : Styles.color.white)};
  border: ${p =>
    p.completed ? `2px solid ${Styles.color.highlight}` : `2px solid ${Styles.color.grey.eight}`};
  ::before {
    content: '${p => p.value}';
    position: absolute;
    font-size: 0.9rem;
    font-weight: normal;
    top: 0.6rem;
    left: calc((-0.625rem / 4) * ${p => p.value.length || 0});
    ${Styles.mobileTiny`
     font-size: 0.8rem;
   `}
  }
`;
